export default __webpack_public_path__ + "1c5e5ca499ddd76cdcc50f5b9bf65299.png";